import { render } from "./StoreComp.vue?vue&type=template&id=879e2efe&scoped=true"
import script from "./StoreComp.vue?vue&type=script&lang=js"
export * from "./StoreComp.vue?vue&type=script&lang=js"

import "./StoreComp.vue?vue&type=style&index=0&id=879e2efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-879e2efe"]])

export default __exports__